import React from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';
import s from './EditTemplate.css';
import Breadcrumbs from '../../components/Breadcrumbs';
import Textarea from '../../components/Textarea';
import { Link } from 'react-router-dom';
import history from '../../history';
import {fetchDecode} from '../../fetchUtils';

class EditTemplate extends React.Component {
  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
    id: PropTypes.string.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      name: '',
      text: '',
      config: require('Config'),
    };
    this.nameChange = this.nameChange.bind(this);
    this.textChange = this.textChange.bind(this);
  }

  componentDidMount() {
    fetchDecode(this.state.config.serverUrl + `texts/${this.props.id}`, message)
      .then((response) => {
        this.setState({ name: response.name, text: response.text });
      });
  }

  nameChange(event) {
    this.setState({ name: event.target.value });
  }

  textChange(value) {
    this.setState({ text: value });
  }

  successMessage = () => {
    message.success(this.props.locale.messageSuccess, 2);
  };

  errorMessage = (error) => {
    message.error(`${this.props.locale.messageError} ${error}`, 5);
  };

  saveTemplate = (e) => {
    e.preventDefault();
    fetch(this.state.config.serverUrl + `texts/${this.props.id}`,
      {
        headers: new Headers({
            'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
            'Content-Type': 'application/json',
            'username': `${sessionStorage.getItem('username')}`
        }),
        method: 'PUT',
        body: JSON.stringify({ name: this.state.name, text: this.state.text }),
      },
    )
      .then((response) => {
        if (response.status === 204) {
          this.successMessage();
            history.push('/templates');
        } else {
          this.errorMessage(response.statusText);
        }
      });
  };

  render() {
    return (
      <div className={s.root}>
        <Breadcrumbs title={this.props.locale.breadcrumbs} link="/templates" />
        <h1>{this.props.locale.title}</h1>
        <form onSubmit={this.saveTemplate}>
          <label className={s.input_wrapper} htmlFor="input">
            <span className={s.input_name}>{this.props.locale.nameLabel}</span>
            <input
              className={s.text_input}
              name="input"
              placeholder={this.props.locale.namePlaceholder}
              value={this.state.name}
              onChange={this.nameChange}
            />
          </label>
          <label className={s.input_wrapper} htmlFor="message">
            <span className={s.input_name}>{this.props.locale.textLabel}</span>
            <Textarea
              name="message"
              rows="4"
              placeholder={this.props.locale.textPlaceholder}
              value={this.state.text}
              ontextchange={this.textChange}
              showsaveoption={false}
            />
          </label>
          <div className={s.button_wrapper}>
            <Link className={s.btn_warning} to="/templates">{this.props.locale.buttonCancel}</Link>
            <button className={s.btn_primary}>{this.props.locale.buttonAdd}</button>
          </div>
        </form>
      </div>
    );
  }
}

export default (EditTemplate);




// WEBPACK FOOTER //
// ./src/routes/templates/EditTemplate.js